import { createRoot } from 'react-dom/client';

// React 18/19 replaced the imperative `ReactDOM.render(el, container)` /
// `ReactDOM.unmountComponentAtNode(container)` pair with `createRoot`. A root
// must be created once per container and reused, then unmounted via the root
// handle. These helpers keep a container -> root map so the legacy imperative
// call sites (modals mounted into a fixed DOM node) can render and later unmount
// without threading the root reference through component state.
const rootsByContainer = new WeakMap();

export function renderInContainer(element, container) {
  let root = rootsByContainer.get(container);
  if (!root) {
    root = createRoot(container);
    rootsByContainer.set(container, root);
  }
  root.render(element);
  return root;
}

export function unmountContainer(container) {
  const root = rootsByContainer.get(container);
  if (!root) {
    return false;
  }
  root.unmount();
  rootsByContainer.delete(container);
  return true;
}
